/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { LegalDocumentDispositionDto } from '../models';
// @ts-ignore
import type { LegalDocumentInfoDto } from '../models';
// @ts-ignore
import type { LegalDocumentTypeDto } from '../models';
/**
 * LegalDocumentsApi - axios parameter creator
 * @export
 */
export const LegalDocumentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Stabilny adres — nie zmienia się przy publikacji nowej wersji, więc podmiana regulaminu jest widoczna pod tym samym linkiem. Odpowiedź ma ETag zależny od numeru wersji: przeglądarka przysyła `If-None-Match` i dostaje 304, dopóki nie zostanie opublikowana nowa wersja. 
         * @summary Pobierz plik aktualnej wersji dokumentu prawnego
         * @param {LegalDocumentTypeDto} documentType Rodzaj dokumentu prawnego
         * @param {string} [ifNoneMatch] ETag wersji, którą przeglądarka ma już w cache.
         * @param {LegalDocumentDispositionDto} [disposition] &#x60;inline&#x60; (domyślnie) wyświetla PDF w przeglądarce, &#x60;attachment&#x60; wymusza pobranie — furtka na wypadek polityki przeglądarki blokującej podgląd PDF u klienta. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCurrentLegalDocument: async (documentType: LegalDocumentTypeDto, ifNoneMatch?: string, disposition?: LegalDocumentDispositionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentType' is not null or undefined
            assertParamExists('downloadCurrentLegalDocument', 'documentType', documentType)
            const localVarPath = `/api/v1/legal-documents/{documentType}/current/content`
                .replace(`{${"documentType"}}`, encodeURIComponent(String(documentType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (disposition !== undefined) {
                localVarQueryParameter['disposition'] = disposition;
            }


    
            if (ifNoneMatch != null) {
                localVarHeaderParameter['If-None-Match'] = String(ifNoneMatch);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Dostępne dla każdego zalogowanego użytkownika — stopka aplikacji pyta o to na każdym widoku. Gdy nie wgrano jeszcze żadnej wersji, zwracane jest 200 z `available: false` (a nie 404), bo brak regulaminu to normalny stan początkowy, a nie błąd — front po prostu nie pokazuje odnośnika. 
         * @summary Metadane aktualnej wersji dokumentu prawnego
         * @param {LegalDocumentTypeDto} documentType Rodzaj dokumentu prawnego
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentLegalDocument: async (documentType: LegalDocumentTypeDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentType' is not null or undefined
            assertParamExists('getCurrentLegalDocument', 'documentType', documentType)
            const localVarPath = `/api/v1/legal-documents/{documentType}/current`
                .replace(`{${"documentType"}}`, encodeURIComponent(String(documentType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LegalDocumentsApi - functional programming interface
 * @export
 */
export const LegalDocumentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LegalDocumentsApiAxiosParamCreator(configuration)
    return {
        /**
         * Stabilny adres — nie zmienia się przy publikacji nowej wersji, więc podmiana regulaminu jest widoczna pod tym samym linkiem. Odpowiedź ma ETag zależny od numeru wersji: przeglądarka przysyła `If-None-Match` i dostaje 304, dopóki nie zostanie opublikowana nowa wersja. 
         * @summary Pobierz plik aktualnej wersji dokumentu prawnego
         * @param {LegalDocumentTypeDto} documentType Rodzaj dokumentu prawnego
         * @param {string} [ifNoneMatch] ETag wersji, którą przeglądarka ma już w cache.
         * @param {LegalDocumentDispositionDto} [disposition] &#x60;inline&#x60; (domyślnie) wyświetla PDF w przeglądarce, &#x60;attachment&#x60; wymusza pobranie — furtka na wypadek polityki przeglądarki blokującej podgląd PDF u klienta. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadCurrentLegalDocument(documentType: LegalDocumentTypeDto, ifNoneMatch?: string, disposition?: LegalDocumentDispositionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadCurrentLegalDocument(documentType, ifNoneMatch, disposition, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegalDocumentsApi.downloadCurrentLegalDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Dostępne dla każdego zalogowanego użytkownika — stopka aplikacji pyta o to na każdym widoku. Gdy nie wgrano jeszcze żadnej wersji, zwracane jest 200 z `available: false` (a nie 404), bo brak regulaminu to normalny stan początkowy, a nie błąd — front po prostu nie pokazuje odnośnika. 
         * @summary Metadane aktualnej wersji dokumentu prawnego
         * @param {LegalDocumentTypeDto} documentType Rodzaj dokumentu prawnego
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentLegalDocument(documentType: LegalDocumentTypeDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LegalDocumentInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentLegalDocument(documentType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LegalDocumentsApi.getCurrentLegalDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LegalDocumentsApi - factory interface
 * @export
 */
export const LegalDocumentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LegalDocumentsApiFp(configuration)
    return {
        /**
         * Stabilny adres — nie zmienia się przy publikacji nowej wersji, więc podmiana regulaminu jest widoczna pod tym samym linkiem. Odpowiedź ma ETag zależny od numeru wersji: przeglądarka przysyła `If-None-Match` i dostaje 304, dopóki nie zostanie opublikowana nowa wersja. 
         * @summary Pobierz plik aktualnej wersji dokumentu prawnego
         * @param {LegalDocumentTypeDto} documentType Rodzaj dokumentu prawnego
         * @param {string} [ifNoneMatch] ETag wersji, którą przeglądarka ma już w cache.
         * @param {LegalDocumentDispositionDto} [disposition] &#x60;inline&#x60; (domyślnie) wyświetla PDF w przeglądarce, &#x60;attachment&#x60; wymusza pobranie — furtka na wypadek polityki przeglądarki blokującej podgląd PDF u klienta. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadCurrentLegalDocument(documentType: LegalDocumentTypeDto, ifNoneMatch?: string, disposition?: LegalDocumentDispositionDto, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.downloadCurrentLegalDocument(documentType, ifNoneMatch, disposition, options).then((request) => request(axios, basePath));
        },
        /**
         * Dostępne dla każdego zalogowanego użytkownika — stopka aplikacji pyta o to na każdym widoku. Gdy nie wgrano jeszcze żadnej wersji, zwracane jest 200 z `available: false` (a nie 404), bo brak regulaminu to normalny stan początkowy, a nie błąd — front po prostu nie pokazuje odnośnika. 
         * @summary Metadane aktualnej wersji dokumentu prawnego
         * @param {LegalDocumentTypeDto} documentType Rodzaj dokumentu prawnego
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentLegalDocument(documentType: LegalDocumentTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<LegalDocumentInfoDto> {
            return localVarFp.getCurrentLegalDocument(documentType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LegalDocumentsApi - interface
 * @export
 * @interface LegalDocumentsApi
 */
export interface LegalDocumentsApiInterface {
    /**
     * Stabilny adres — nie zmienia się przy publikacji nowej wersji, więc podmiana regulaminu jest widoczna pod tym samym linkiem. Odpowiedź ma ETag zależny od numeru wersji: przeglądarka przysyła `If-None-Match` i dostaje 304, dopóki nie zostanie opublikowana nowa wersja. 
     * @summary Pobierz plik aktualnej wersji dokumentu prawnego
     * @param {LegalDocumentTypeDto} documentType Rodzaj dokumentu prawnego
     * @param {string} [ifNoneMatch] ETag wersji, którą przeglądarka ma już w cache.
     * @param {LegalDocumentDispositionDto} [disposition] &#x60;inline&#x60; (domyślnie) wyświetla PDF w przeglądarce, &#x60;attachment&#x60; wymusza pobranie — furtka na wypadek polityki przeglądarki blokującej podgląd PDF u klienta. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegalDocumentsApiInterface
     */
    downloadCurrentLegalDocument(documentType: LegalDocumentTypeDto, ifNoneMatch?: string, disposition?: LegalDocumentDispositionDto, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * Dostępne dla każdego zalogowanego użytkownika — stopka aplikacji pyta o to na każdym widoku. Gdy nie wgrano jeszcze żadnej wersji, zwracane jest 200 z `available: false` (a nie 404), bo brak regulaminu to normalny stan początkowy, a nie błąd — front po prostu nie pokazuje odnośnika. 
     * @summary Metadane aktualnej wersji dokumentu prawnego
     * @param {LegalDocumentTypeDto} documentType Rodzaj dokumentu prawnego
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegalDocumentsApiInterface
     */
    getCurrentLegalDocument(documentType: LegalDocumentTypeDto, options?: RawAxiosRequestConfig): AxiosPromise<LegalDocumentInfoDto>;

}

/**
 * LegalDocumentsApi - object-oriented interface
 * @export
 * @class LegalDocumentsApi
 * @extends {BaseAPI}
 */
export class LegalDocumentsApi extends BaseAPI implements LegalDocumentsApiInterface {
    /**
     * Stabilny adres — nie zmienia się przy publikacji nowej wersji, więc podmiana regulaminu jest widoczna pod tym samym linkiem. Odpowiedź ma ETag zależny od numeru wersji: przeglądarka przysyła `If-None-Match` i dostaje 304, dopóki nie zostanie opublikowana nowa wersja. 
     * @summary Pobierz plik aktualnej wersji dokumentu prawnego
     * @param {LegalDocumentTypeDto} documentType Rodzaj dokumentu prawnego
     * @param {string} [ifNoneMatch] ETag wersji, którą przeglądarka ma już w cache.
     * @param {LegalDocumentDispositionDto} [disposition] &#x60;inline&#x60; (domyślnie) wyświetla PDF w przeglądarce, &#x60;attachment&#x60; wymusza pobranie — furtka na wypadek polityki przeglądarki blokującej podgląd PDF u klienta. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegalDocumentsApi
     */
    public downloadCurrentLegalDocument(documentType: LegalDocumentTypeDto, ifNoneMatch?: string, disposition?: LegalDocumentDispositionDto, options?: RawAxiosRequestConfig) {
        return LegalDocumentsApiFp(this.configuration).downloadCurrentLegalDocument(documentType, ifNoneMatch, disposition, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Dostępne dla każdego zalogowanego użytkownika — stopka aplikacji pyta o to na każdym widoku. Gdy nie wgrano jeszcze żadnej wersji, zwracane jest 200 z `available: false` (a nie 404), bo brak regulaminu to normalny stan początkowy, a nie błąd — front po prostu nie pokazuje odnośnika. 
     * @summary Metadane aktualnej wersji dokumentu prawnego
     * @param {LegalDocumentTypeDto} documentType Rodzaj dokumentu prawnego
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegalDocumentsApi
     */
    public getCurrentLegalDocument(documentType: LegalDocumentTypeDto, options?: RawAxiosRequestConfig) {
        return LegalDocumentsApiFp(this.configuration).getCurrentLegalDocument(documentType, options).then((request) => request(this.axios, this.basePath));
    }
}

